export const strings = {
	en: {
		softwareDevelopmentSnake: 'software_development',
		webDesignSnake: 'web_design'
	},
	de: {
		softwareDevelopmentSnake: 'software_entwicklung',
		webDesignSnake: 'web_entwicklung'
	}
};